import request from '@/utils/request'

const baseUrl = '/erp/supplier'

export const listSupplier = (enabledOnly = false) => request({
  url: baseUrl + '/list', method: 'get', params: { enabledOnly }
})
export const saveSupplier = data => request({ url: baseUrl + '/save', method: 'post', data })
export const setSupplierEnabled = (id, enabled) => request({
  url: baseUrl + '/status', method: 'post', data: { id, enabled }
})
export const deleteSupplier = id => request({
  url: baseUrl + '/delete', method: 'post', data: { id }
})
